import React from "react";
import PropTypes from "prop-types";
import PillButton from "./Button/PillButton.jsx";

/**
 * ProductTag Atom - Displays a single product tag as a pill button
 * @component
 * @example
 * <ProductTag tag="electronics" onClick={(tag) => console.log(tag)} />
 */
const ProductTag = ({
    tag,
    onClick,
    variant = "",
    className = "",
}) => {
    return (
        <PillButton
            variant={variant}
            size="xs"
            className={`mx-1 my-1 text-xs font-semibold ${className}`}
            onClick={() => onClick?.(tag)}
        >
            #{tag}
        </PillButton>
    );
};

ProductTag.propTypes = {
    tag: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    variant: PropTypes.string,
    className: PropTypes.string,
};

export default ProductTag;
